const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="loader border-r-[#FAC70C] w-[50px]"></div>
    </div>
  );
};

export default LoadingSpinner;
